import React, { useEffect } from 'react';
import { ErrorPageTypes } from '../../../../types/index';
import tracker from '../../../../service/tracker';
import OopsPage from './OopsPage';

const ErrorPage = ({ errorContext }) => {

    useEffect(() => {
        tracker.error();

    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <div className="listings-perseus">
            <OopsPage errorContext={errorContext}/>
        </div>
    );
};

ErrorPage.propTypes = ErrorPageTypes;

export default ErrorPage;
